// extracted by mini-css-extract-plugin
export var menuItem = "D_vJ d_fZ d_bz d_bD d_bP d_bf";
export var menuItemSub = "D_vK d_Z d_bz d_bP";
export var menuMainLink = "D_vL d_f0 d_dB";
export var menuLink = "D_vM d_f0 d_dB";
export var icon = "D_p9 d_bC d_bP";
export var divider = "D_vN d_bC d_bP";
export var sublinks = "D_vP";
export var link = "D_mC";
export var Link = "D_vm C_vm C_tH C_t1";